module.exports = __webpack_public_path__ + "static/writing-image-00d255c8312614d2b1908a25c5618d6b.png";